function zeros(length) {
  return new Array(length + 1).join('0');
}

function expandExponentialNumber(value) {
  const source = String(value);
  const match = /^(\d+)(?:\.(\d*))?[eE]([+-]?\d+)$/.exec(source);

  if (!match) return source;

  const integerPart = match[1];
  const fractionPart = match[2] || '';
  const exponent = parseInt(match[3], 10);
  const digits = integerPart + fractionPart;
  const decimalIndex = integerPart.length + exponent;

  if (decimalIndex <= 0) {
    return '0.' + zeros(-decimalIndex) + digits;
  }

  if (decimalIndex >= digits.length) {
    return digits + zeros(decimalIndex - digits.length);
  }

  return digits.slice(0, decimalIndex) + '.' + digits.slice(decimalIndex);
}

function incrementInteger(value) {
  const digits = value.split('');
  let index = digits.length - 1;

  while (index >= 0 && digits[index] === '9') {
    digits[index] = '0';
    index -= 1;
  }

  if (index < 0) {
    digits.unshift('1');
  } else {
    digits[index] = String(parseInt(digits[index], 10) + 1);
  }

  return digits.join('');
}

/**
 * Format a non-negative product price for display.
 *
 * Values with a non-zero remainder after two decimal places are rounded up
 * to the next cent. The source value is never converted through floating
 * point arithmetic, so decimal strings retain their exact meaning.
 *
 * @param {*} value Price to display.
 * @param {boolean} enabled Pass false to bypass formatting.
 * @returns {*} A two-decimal string, or the original value when bypassed or invalid.
 */
export default function productPrice(value, enabled = true) {
  if (enabled === false) return value;
  if (value === null || value === undefined) return value;
  if (typeof value !== 'number' && typeof value !== 'string') return value;
  if (typeof value === 'number' && (!isFinite(value) || value < 0)) return value;

  const source = String(value).trim();
  if (source === '' || source === '--' || source.charAt(0) === '-') return value;

  const decimalSource =
    typeof value === 'number' && /e/i.test(source)
      ? expandExponentialNumber(value)
      : source.replace(/^\+/, '');

  if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(decimalSource)) return value;

  const parts = decimalSource.split('.');
  let integerPart = parts[0] || '0';
  const fractionPart = parts[1] || '';
  let cents = (fractionPart + '00').slice(0, 2);

  integerPart = integerPart.replace(/^0+(?=\d)/, '');

  if (/[1-9]/.test(fractionPart.slice(2))) {
    const incrementedCents = parseInt(cents, 10) + 1;

    if (incrementedCents === 100) {
      integerPart = incrementInteger(integerPart);
      cents = '00';
    } else {
      cents = incrementedCents < 10
        ? '0' + incrementedCents
        : String(incrementedCents);
    }
  }

  return integerPart + '.' + cents;
}



// WEBPACK FOOTER //
// ./src/assets/plugin/filters/productPrice.js